import {RTC_PROTOCOL_V1, type CallIntent} from '@phonehq/rtc-core';

export interface RtcNotificationEventLike {
    getType(): string;
    getId?(): string | undefined;
    getContent(): Record<string, unknown>;
    isRedacted?(): boolean;
}

export function isRtcNotificationEvent(event: Pick<RtcNotificationEventLike, 'getType'>): boolean {
    return event.getType() === RTC_PROTOCOL_V1.notificationEventType;
}

export function rtcNotificationIntent(event: Pick<RtcNotificationEventLike, 'getContent'>): CallIntent {
    return event.getContent()?.['m.call.intent'] === 'video' ? 'video' : 'audio';
}

export function latestRtcNotification<T extends RtcNotificationEventLike>(events: readonly T[]): T | null {
    for (let index = events.length - 1; index >= 0; index--) {
        const event = events[index];
        if (!isRtcNotificationEvent(event)) continue;
        if (typeof event.isRedacted === 'function' && event.isRedacted()) continue;
        return event;
    }
    return null;
}

export function latestRtcNotificationId(events: readonly RtcNotificationEventLike[]): string | null {
    return latestRtcNotification(events)?.getId?.() ?? null;
}

export function rtcNotificationPreviewText(intent: CallIntent, oneToOne: boolean): string {
    if (intent === 'video') {
        return oneToOne ? '📹 Video call' : '📹 Group video call';
    }
    return oneToOne ? '📞 Call' : '📞 Group call';
}
